import styled, { css } from 'styled-components';
import { CloseSecondary } from 'icons/CloseSecondary';

export const InputWrapper = styled.div<{
  $withClear?: boolean;
  $fullwidth?: boolean;
}>`
  position: relative;

  && .ant-input-affix-wrapper {
    border-width: 1.2px;
    border-radius: 12px;

    &.ant-input-affix-wrapper-focused {
      box-shadow: none;
      border-color: var(--v3-primary-color);
      background: var(--v3-black-0);
    }

    &:hover,
    &:focus {
      border-color: var(--v3-primary-color);
      background: var(--v3-black-0);
    }
  }

  && input {
    border-width: 1.2px;
    border-radius: 12px;
    background: var(--v3-black-0);
    height: 40px;
    color: var(--v3-text-color);

    ${props =>
      props.$withClear &&
      css`
        padding-right: 56px;
      `}

    &[type="password"] {
      padding-left: unset;
    }

    &[disabled] {
      background: var(--v3-black-2);
    }

    &[class$='-input-status-error'] {
      background: var(--v3-black-0);
    }

    &::placeholder {
      color: var(--v3-text-color-secondary);
    }

    &:not([type='password']):hover,
    &:focus {
      border-color: var(--v3-primary-color);
      background: var(--v3-black-0);

      &:focus {
        box-shadow: none;
      }

      &[disabled] {
        border-color: var(--v3-black-2);
        background: var(--v3-black-2);
      }
    }
  }
  ${props =>
    props.$fullwidth &&
    css`
       {
        flex: 1;
        width: 100%;
      }
    `}
`;

export const InputLabel = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: var(--v3-text-color);
  line-height: 20px;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
`;

export const InputErrorText = styled.div`
  text-align: right;
  font-size: 12px;
  font-weight: normal;
  color: var(--v3-error-color);
  line-height: 14px;
  letter-spacing: 0.3px;
  margin-top: 4px;
`;

export const ClearIcon = styled(CloseSecondary)`
  position: absolute;
  right: 16px;
  font-size: 24px;
  display: flex;
  align-items: center;
  top: 0;
  bottom: 0;
  cursor: pointer;
`;
